// extracted by mini-css-extract-plugin
module.exports = {"item-card-img-wrap":"style_item-card-img-wrap__kndRq","item-card-img":"style_item-card-img__Oz2W1","inscription-info-wrap":"style_inscription-info-wrap__ZWm_2"};